import {environment} from '../../../environments/environment';

export const indexesHidesBackTestData = (): string[] => {
  return environment.launchDateFilteredTickers.replace(/\s+/g, '').split(',')
}
